import React from 'react';
import PropTypes from 'prop-types';
import StandardKnob from './StandardKnob';
import EffectMoveAction from '../actions/EffectMoveAction';
import EffectRemoveAction from '../actions/EffectRemoveAction';

export default class ParameterUnit extends React.Component {
	static propTypes = {
		name: PropTypes.string,
		type: PropTypes.string,
		position: PropTypes.number
	};

	static contextTypes = {
		executeAction: PropTypes.func.isRequired
	};

	constructor(props) {
		super(props);
	}

	handleMoveEffectLeft(e) {
		if(this.props.position !== 1) {
			this.context.executeAction(EffectMoveAction, {
				effect: this.props.position-1,
				amount: -1
			});
		}
	}

	handleMoveEffectRight(e) {
		if(this.props.position !== this.props.count) {
			this.context.executeAction(EffectMoveAction, {
				effect: this.props.position-1,
				amount: 1
			});
		}
	}

	handleRemove(e) {
		this.context.executeAction(EffectRemoveAction, {
			effect: this.props.position-1
		});
	}

	render() {
		var controls = [], i, j;

		this.props.parameters.forEach((value, key) => {
			controls.push(<StandardKnob param={value} key={key}/>)
		});

		var rows = [];

		for (i=0,j=controls.length; i<j; i+=2) {
			rows.push(<div className="knob-row" key={~~(i/2)}>
				{controls[i]}
				{controls[i+1]}
			</div>);
		}


		var footerControls = [];

		if(this.props.type == "effect") {
			footerControls.push(<div className="effect-number">{this.props.number}</div>);
			footerControls.push(
				<div className="shift-effect-controls">
					<i className="material-icons" onClick={this.handleRemove.bind(this)}>close</i>
					<i className={(this.props.position === 1 ? "disabled ": "") + "material-icons"}
					   onClick={this.handleMoveEffectLeft.bind(this)}>chevron_left</i>
					<i className={(this.props.position === this.props.count ? "disabled ": "") + "material-icons"}
					   onClick={this.handleMoveEffectRight.bind(this)}>chevron_right</i>
				</div>
			);
		}

		return (
			<div className="ParameterUnit">
				<header className={this.props.type}>{this.props.name}</header>
				{rows}
				<footer>
					{footerControls}

				</footer>
			</div>
		);
	}
}
